module.exports = __webpack_public_path__ + "static/img/Swiftkey.b1044870.png";